export default "__VITE_ASSET__BdzvioHr__"